<modal-popup [flexible]="true" [focusOnOpen]="false" [isOpen]="true" (onClose)="close()"
    [title]="title"
    [flexible]="true"
    [isLoading]="loading"
    [afterTitle]="actionButtons">
    <div class="container">

        <div class="group" style="width: 50%;">
            <!-- text area for claim text -->
            <div class="claim-text-container">
                <input-wrap label="{{ 'translate.claims-view.claimText' | translate }}" [required]="true">
                    <textarea [(ngModel)]="claim.claimText"
                    [readonly]="mode == 'view'"
                    pTextarea
                        placeholder="{{ 'translate.claims-view.claimText' | translate }}" pTextarea></textarea>
                </input-wrap>
            </div>
            <ng-container *ngIf="!(claim.contentType == 'TEXT_CONTENT')">
            <!-- Content - Associated Text -->
            <div class="content-container">
                <div class="header">
                    <h4 class="norm-title fs-small t-row--small t-buttonSet-child">{{ "translate.general.associatedText"
                        | translate }} </h4>
                    <a *ngIf="mode != 'view'" (click)="addAssociatedText()">
                        <i [ngClass]="'fas fa-plus'"></i>
                    </a>
            
                </div>
                <div class="rows">
                    <ng-container *ngFor="let addedAssocText of claim.associatedText; let i=index">
                        <div class="row">
                            <textarea [(ngModel)]="addedAssocText.assocPhraseText"
                                [readonly]="mode == 'view'"
                                pTextarea
                                placeholder="{{ 'translate.general.associatedText' | translate }}" class="t-input" type="text"
                                >
                            </textarea>
                            <a *ngIf="mode != 'view'" (click)="removeAssociatedText(addedAssocText)">
                                <i [ngClass]="'fas fa-minus'"></i>
                            </a>
                        </div>
                    </ng-container>
                </div>
            </div>
            
            <!-- Footnotes -->
            <div class="footnotes-container">
                <div class="header">
                    <h4 class="norm-title fs-small t-row--small t-buttonSet-child">{{ "translate.rev.footnotes" | translate }}</h4>
                    <a *ngIf="mode != 'view'" (click)="addFootnotes()">
                        <i [ngClass]="'fas fa-plus'"></i>
                    </a>
                </div>
                <div class="rows">
                    <ng-container *ngFor="let addedFootnote of claim.footnotes; let i = index">
                        <div class="row">
                            <textarea pTextarea [(ngModel)]="addedFootnote.footnoteText"
                                placeholder="{{ 'translate.general.claims-view.footnotes' | translate }}" class="t-input"
                                type="text"
                                [readonly]="mode == 'view'">
                            </textarea>
                            <a *ngIf="mode != 'view'" (click)="removeFootnotes(addedFootnote)">
                                <i [ngClass]="'fas fa-minus'"></i>
                            </a>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="references-container">
                <div class="header">
                    <h4 class="norm-title fs-small t-row--small t-buttonSet-child">{{ 'translate.claims-view.references'
                        | translate }}
                    </h4>
                    <a *ngIf="mode !== 'view'"  (click)="addReference()">
                        <i [ngClass]="'fas fa-plus'"></i>
                    </a>
                </div>
                <div *ngIf="refInitialized" class="rows">
                    <ng-container *ngFor="let claimReference of claim.references">
                        <div class="row">
                            <claim-references-editor [claimReferences]="claim.references"
                                [mode]="mode"
                                [refDocs]="refDocs"
                                (removeClaimReference)="removeReference(claimReference)" 
                                [filteredRefDocs]="filteredRefDocs"
                                [claimReference]="claimReference" [catVersionId]="catVersionId">
            
                            </claim-references-editor>
                        </div>
                    </ng-container>
                </div>
            </div>
            </ng-container>
        </div>
        <div class="group right-column">
            <input-wrap  label="{{ 'translate.create-claim.contentType' | translate }}" [required]="true">
                <p-select [readonly]="mode !== 'create'" [options]="contentTypeOptions" [(ngModel)]="claim.contentType" optionLabel="label"
                (onChange)="onSelectPhraseContentType($event)"
                    optionValue="value">

                </p-select>
            </input-wrap>
            <input-wrap label="{{ 'translate.create-claim.status' | translate }}"
                [required]="true">
                <p-selectButton [disabled]="mode !== 'create'" [options]="statusOptions" [(ngModel)]="claim.status" optionLabel="label"
                    optionValue="value">
                </p-selectButton>
            </input-wrap>
            <input-wrap  [readonly]="mode == 'view'" class="metadata-label"
            label="{{ 'translate.add-doc-metadata.metadata' | translate }}" [required]="false">

                <div class="metadata">

                    <add-doc-metadata #metadataGroup [catVersionId]="catVersionId" [entityType]="'CLAIM'"
                        [docMetadataHandler]="docMetadataHandler" [lang]="lang" [catSystemVersion]="catSystemVersion"
                        [envId]="envId"
                        (initializedMetadataGroups)="initialized = true; setInitValues()"
                        [readonly]="mode == 'view'">
                    </add-doc-metadata>
                </div>
            </input-wrap>

        </div>

    </div>

    <ng-template #actionButtons>
        <div class="t-small" *ngIf="mode == 'create'">
            <button class="t-button t-button-warn" [disabled]="!isValid()" (click)="onSaveClaimChanges()">
                {{ "translate.general.saveChanges" | translate }}
            </button>
        </div>
        <ng-container *ngIf="initialized && mode == 'edit'">
            <div class="t-small">
                <button class="t-button t-button-warn" [disabled]="!isValid() || !hasChanges()" (click)="onEditClaimChanges()">
                    {{ "translate.general.saveChanges" | translate }}
                </button>
            </div>
            <div class="t-small"  class="discard-changes-button" *ngIf="hasChanges()">
                <button class="t-button-outline t-button-warn"  (click)="discardChanges()">
                    {{ "translate.general.discardChanges" | translate }}
                </button>
            </div>
        </ng-container>
    </ng-template>

</modal-popup>